
// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import BookInventory from "../../components/dashboard/BookInventory";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <BookInventory />
    </DashboardLayout>
  );
}
